import styled from 'styled-components';

// ------------------------------
export const body = styled.div`
display: flex ;
height:100vh ;
width: 100vw;
min-width: 300px ;
margin: 0 ;
padding: 0 ;
font-size:14px;

background-color: black;
flex-direction: column ;
align-items: center ;

button{
  cursor: pointer;
}
`
// ---------------------------------
export const bodyMeio = styled.div` 
display:flex;
flex-direction: column ;
width: 100% ;
background-color: black ;
align-items: center ;
margin-top:60px ;

button{
  width: 100px ;
}
`
//---------------------------------------------
export const imagem = styled.div`
display: flex ;
width: 100% ;
justify-content: center ;

img{
  margin: 15px 0 ;
  width: 80% ;
  max-width: 1300px ;
}

`

export const actions = styled.div`
display: flex;
width: 80%;
max-width: 1300px;
justify-content: flex-end;
margin-top: 8px;

button {
  min-height: 44px;
  border: 1px solid #01ca55;
  background-color: transparent;
  color: #01ca55;
  padding: 0 16px;
  border-radius: 8px;
  font-size: clamp(12px, 2vw, 14px);
  transition: all .2s ease;

  &:hover {
    background-color: #01ca55;
    color: black;
  }
}

@media (max-width: 780px) {
  width: 90%;
  justify-content: center;
}
`

export const modalOverlay = styled.div`
position: fixed;
inset: 0;
background-color: ${props => props.$classic ? 'rgba(0, 0, 0, 0.65)' : '#0f1311'};
display: flex;
align-items: ${props => props.$classic ? 'center' : 'stretch'};
justify-content: ${props => props.$classic ? 'center' : 'stretch'};
z-index: 99;
padding: ${props => props.$classic ? '20px' : '0'};
`

export const modalContainer = styled.div`
width: ${props => props.$classic ? 'min(980px, 95vw)' : '100%'};
height: ${props => props.$classic ? 'auto' : '100%'};
max-height: ${props => props.$classic ? '92vh' : 'none'};
overflow: hidden;
background-color: #1b1b1b;
border: ${props => props.$classic ? '1px solid #2f2f2f' : '0'};
border-radius: ${props => props.$classic ? '12px' : '0'};
padding: 18px 22px;
color: #f0f0f0;
display: flex;
flex-direction: column;

@media (max-width: 780px) {
  padding: 12px;
}
`

export const modalHeader = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
border-bottom: 1px solid #333;
padding-bottom: 12px;

h3 {
  margin: 0;
  color: #01ca55;
}

button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #01ca55;
  background: transparent;
  color: #01ca55;
  font-weight: bold;
}
`

export const wizardContainer = styled.div`
display: grid;
grid-template-columns: 1fr auto 1fr;
gap: 12px;
align-items: center;
margin-top: 14px;
padding: 10px;
border: 1px solid #2f2f2f;
border-radius: 8px;
background-color: #171717;

@media (max-width: 780px) {
  grid-template-columns: 1fr;
  gap: 8px;
}
`

export const wizardStep = styled.div`
display: flex;
align-items: center;
gap: 10px;
opacity: ${props => props.status === 'pending' ? 0.6 : 1};

strong {
  display: block;
  color: ${props => props.status === 'done' ? '#8de3b2' : '#f0f0f0'};
  font-size: 13px;
}

span {
  display: block;
  color: #a6a6a6;
  font-size: 12px;
}
`

export const wizardCircle = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 28px;
height: 28px;
border-radius: 50%;
font-size: 13px;
font-weight: 700;
border: 1px solid ${props => {
    if (props.status === 'done') return '#01ca55';
    if (props.status === 'active') return '#8de3b2';
    return '#4a4a4a';
  }};
color: ${props => {
    if (props.status === 'done') return '#01ca55';
    if (props.status === 'active') return '#8de3b2';
    return '#868686';
  }};
background-color: ${props => props.status === 'done' ? 'rgba(1, 202, 85, 0.1)' : 'transparent'};
`

export const wizardLine = styled.div`
height: 2px;
width: 100%;
background-color: ${props => props.active ? '#01ca55' : '#3a3a3a'};

@media (max-width: 780px) {
  height: 18px;
  width: 2px;
  justify-self: center;
}
`

export const modalStatus = styled.div`
display: flex;
gap: 24px;
margin-top: 12px;
flex-wrap: wrap;

strong {
  color: #01ca55;
}
`

export const modalContent = styled.div`
margin-top: 14px;
flex: 1;
overflow-y: auto;
padding-right: 4px;
`

export const infoBox = styled.div`
display: flex;
flex-direction: column;
gap: 6px;
background-color: #222;
border: 1px solid #363636;
border-radius: 8px;
padding: 12px;

p {
  margin: 0;
}

span {
  color: #8de3b2;
  font-size: 13px;
  word-break: break-all;
}
`

export const formGrid = styled.div`
display: grid;
grid-template-columns: repeat(2, minmax(0, 1fr));
gap: 14px;
margin-top: 14px;

label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  min-width: 0;
  overflow-wrap: anywhere;
}

input,
select {
  width: 100%;
  box-sizing: border-box;
  min-height: 38px;
  border: 1px solid #3a3a3a;
  background-color: #0f0f0f;
  color: #f5f5f5;
  border-radius: 6px;
  padding: 0 10px;
  outline: 0;
}

input:focus,
select:focus {
  border-color: #01ca55;
}

small {
  display: block;
  overflow-wrap: anywhere;
}

@media (max-width: 780px) {
  grid-template-columns: 1fr;
}
`

export const inlineInput = styled.div`
display: flex;
gap: 8px;

button {
  min-width: 74px;
  min-height: 38px;
  border: 1px solid #01ca55;
  background: transparent;
  color: #01ca55;
  border-radius: 6px;
}
`

export const feedback = styled.div`
margin-top: 12px;
padding: 10px;
border-radius: 8px;
font-size: 13px;
border: 1px solid ${props => props.type === 'error' ? '#ff5858' : '#01ca55'};
color: ${props => props.type === 'error' ? '#ff8a8a' : '#8de3b2'};
background-color: ${props => props.type === 'error' ? 'rgba(255, 88, 88, 0.08)' : 'rgba(1, 202, 85, 0.08)'};
`

export const modalFooter = styled.div`
display: flex;
justify-content: flex-end;
gap: 10px;
margin-top: 16px;

button {
  min-height: 40px;
  border-radius: 6px;
  border: 1px solid #3b3b3b;
  background-color: #252525;
  color: #f0f0f0;
  padding: 0 14px;
}

button.primary {
  border-color: #01ca55;
  color: #01ca55;
}

button.ghost {
  border-color: #666;
}

button:disabled {
  cursor: not-allowed;
  opacity: .6;
}

@media (max-width: 780px) {
  flex-direction: column;

  button {
    width: 100%;
  }
}
`

export const templateTestBox = styled.div`
margin-top: 14px;
padding: 12px;
border: 1px solid #2f3f35;
background-color: #161c18;
border-radius: 8px;

h4 {
  margin: 0 0 10px 0;
  color: #8de3b2;
  font-size: 14px;
}
`

export const templateActions = styled.div`
display: flex;
justify-content: flex-end;
gap: 8px;
margin-top: 12px;

button {
  min-height: 40px;
  border-radius: 6px;
  border: 1px solid #01ca55;
  color: #01ca55;
  background-color: transparent;
  padding: 0 14px;
}

button:disabled {
  cursor: not-allowed;
  opacity: .6;
}

@media (max-width: 780px) {
  button {
    width: 100%;
  }
}
`

export const templateWorkbench = styled.div`
display: grid;
grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
gap: 16px;
align-items: start;

@media (max-width: 1200px) {
  grid-template-columns: 1fr;
}
`

export const templatePane = styled.div`
display: grid;
gap: 12px;
min-width: 0;
`

export const templateStage = styled.section`
background: #141a16;
border: 1px solid #2f3f35;
border-radius: 10px;
padding: 12px;

h5 {
  margin: 0;
  color: #c8f6dc;
  font-size: 14px;
}

p {
  margin: 6px 0 0 0;
  color: #a4b3ab;
  font-size: 12px;
}
`

export const stageStatus = styled.span`
display: inline-flex;
align-items: center;
padding: 4px 8px;
border-radius: 999px;
font-size: 11px;
font-weight: 600;
margin-left: 8px;
border: 1px solid ${props => props.done ? '#01ca55' : '#5a6b62'};
color: ${props => props.done ? '#8de3b2' : '#a5b2aa'};
background: ${props => props.done ? 'rgba(1, 202, 85, 0.08)' : 'rgba(90, 107, 98, 0.08)'};
`

export const stageHeader = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
gap: 10px;
flex-wrap: wrap;
`

export const templatePreviewShell = styled.div`
position: sticky;
top: 0;
background: #111814;
border: 1px solid #2f3f35;
border-radius: 10px;
padding: 12px;
min-width: 0;
overflow: hidden;
`

export const credentialsGrid = styled.div`
display: grid;
grid-template-columns: repeat(2, minmax(220px, 1fr));
gap: 10px;
margin-top: 10px;

div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid #345244;
  background-color: rgba(1, 202, 85, 0.06);
  border-radius: 6px;
  padding: 10px;
}

strong {
  color: #8de3b2;
  font-size: 12px;
}

span {
  color: #e7e7e7;
  font-size: 12px;
  word-break: break-all;
}

@media (max-width: 780px) {
  grid-template-columns: 1fr;
}
`
// --------------------------
export const Login = styled.div`
display: flex;
height: 100% ;
position:fixed ;
right:20px ;
border-left:1px solid #5656f7;

@media (max-width: 780px) {
  position:relative ;
  right:0 ;
  border:none ;
};

`
// --------------------------
export const box = styled.div`
display: flex;
flex-direction:column;
width: 20vw ;
min-width:250px ;
max-width:300px ;
align-items: center ;
margin-top:100px ;
margin-left: 20px;

@media (max-width: 780px) {
  margin-top:0 ;
  margin-left: 0;
};

span{
  color: white ;
}

input{
  display: flex ;
  height: 30px ;
  width:95% ;
  font-size:16px;
  padding:5px;
  outline:0;
  transition:all ease .4s;
  border:1px solid black;
  border-radius:3px;
  color: black ;

  &:focus{
    border:1px solid #00c7ff;
  }
}
button{
  width: 100px ;
  height: 25px ;
  margin-top: 10px ;
  border:none ;
  border-radius: 2px ;
  
  &:hover{
    background-color:#00ff9d;
    }
}
`
// ---------------------------
export const box1 = styled.div`
display: flex;
width: 100% ;
align-items: center ;

span{
  height:25px ;
}
input{
  width: 17px;
}
`
// -----------------------------
export const Footer = styled.div`
display: flex ;
align-items: center ;
justify-content: center ;
position:absolute ;
bottom:0px ;
width:100%;
height:25px ;
border-top:1px solid #5656f7;
font-size: 11px ;
color: white ;
div{
  display: flex ;
  margin-right: 10px ;
  align-items: center ;
  color: white ;
  padding: 10px 0 ;
}

`
